import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import SearchFilter from '@ui/components/Button/SearchFilter';
import { useTranslation } from 'react-i18next';
import { FolderEmptyIcon } from '@ui/assets/custom-icons/folder-empty';
import { PrimaryGrid } from '@ui/components/common/Grid';
const ReassignedAttendeesTab = ({ reassignedAttendees, columns, searchValue, onSearchChange }) => {
    const { t } = useTranslation();
    if (reassignedAttendees.length === 0) {
        return (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 320,
                gap: 2
            }, children: [_jsx(FolderEmptyIcon, { size: 160 }), _jsx(Typography, { variant: 'body2', color: 'text.secondary', textAlign: 'center', children: t('events.eventDetails.transportTab.noReassignedYet') })] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { width: '100%', children: _jsx(SearchFilter, { fullWidth: true, searchValue: searchValue, onSearchChange: onSearchChange, placeholder: t('placeholders.search'), breakpoint: 'lg', onClear: () => onSearchChange(''), widthBox: '100%', bgVariant: 'grey8' }) }), _jsx(PrimaryGrid, { columns: columns, rows: reassignedAttendees, showNewHeaderControls: false, isMultiple: false, showHeaderControls: false, hideFooter: true, boxProps: {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        height: 400,
                        width: '100%'
                    }
                } })] }));
};
export default ReassignedAttendeesTab;
